export default __webpack_public_path__ + "static/media/800px-Aspen_Properties.1ceb0b35.png";